module.exports = __webpack_public_path__ + "img/training.3ad4b1b1.png";